import { useEffect } from 'react';

import { AriseBridgeHost } from '@/arise/bridge/AriseBridgeHost';
import {
    DiscordParticipant,
    getDiscordInstanceInfo,
    getDiscordParticipants,
    subscribeToDiscordParticipants,
} from '@/components/DiscordAuthFlow/useDiscord';
import { IS_DISCORD_ACTIVITY } from '@/globals';

export default function useDiscordBridgeEvents(bridge: AriseBridgeHost | null) {
    useEffect(() => {
        if (!bridge || !IS_DISCORD_ACTIVITY) return;

        function send(participants: DiscordParticipant[]) {
            bridge!.sendEvent('discord-participants', { participants });
        }

        async function onGetDiscordParticipants() {
            send(await getDiscordParticipants());
        }

        async function onGetDiscordInstance() {
            bridge!.sendEvent('discord-instance', await getDiscordInstanceInfo());
        }

        bridge.on('get-discord-participants', onGetDiscordParticipants);
        bridge.on('get-discord-instance', onGetDiscordInstance);

        // Push updates to the iframe whenever the participant list changes, and send
        // the initial list once the SDK is ready so it doesn't have to ask.
        const unsubscribe = subscribeToDiscordParticipants(send);
        getDiscordParticipants().then(send);

        return () => {
            bridge.off('get-discord-participants', onGetDiscordParticipants);
            bridge.off('get-discord-instance', onGetDiscordInstance);
            unsubscribe();
        };
    }, [bridge]);
}
